// Planner-Hour Component

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import IconButton from '../../common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Popover from '../../../common/common/popover/popover.jsx'
import SvgIcon from '../../../common/common/svgicon/svgicon.jsx'

class PopoverPlannerHour extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      dataDate: new Date()
    }

    this._data = {
      item: null,
      projects: [],
      positionLeft: 0,
      projectId: '',
      totalHours: 0
    }

    this._references = {
      popoverPlannerHour: React.createRef()
    }

    this._reloadTimer = null
  }

  static get propTypes () {
    return {
      onReload: PropTypes.func,
      onClose: PropTypes.func,
      container: PropTypes.any,
      target: PropTypes.any,
      onChangeHour: PropTypes.func,
      canEdit: PropTypes.bool,
      showAvailableInfo: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      onReload: null,
      onClose: null,
      container: null,
      target: null,
      onChangeHour: null,
      canEdit: true,
      showAvailableInfo: false
    }
  }

  _calculateTotalHours (projects) {
    let totalHours = 0
    projects.forEach(activity => {
      totalHours += activity.noHours
    })

    return totalHours
  }

  _onReload = () => {
    if (this.props.onReload) {
      this.props.onReload(this._data.item.date, projects => {
        this._data.projects = projects
        this._data.totalHours = this._calculateTotalHours(projects)

        this.setState({ dateDate: new Date() })
      })
    }
  }

  show (projects, item, positionLeft = 0, projectId) {
    this._data.item = item
    this._data.projects = projects
    this._data.positionLeft = positionLeft
    this._data.projectId = projectId
    this._data.totalHours = this._calculateTotalHours(projects)

    this.setState({ active: true, dateDate: new Date() })
  }

  hide = () => {
    this.setState({ active: false, dateDate: new Date() })
  }

  render () {
    const { container, target } = this.props
    const { active } = this.state
    const { totalHours, item, projects, projectId, positionLeft } = this._data

    const otherProjects = [...projects]
    const currentProjects = _.remove(
      otherProjects,
      project => project.id === projectId
    )
    const currentProjectTitle =
      currentProjects.length > 0 ? currentProjects[0].title : ''

    const currentProjectNoHours = _.sumBy(currentProjects, function (project) {
      return project.noHours
    })

    return (
      <Popover
        placement='bottom'
        container={container || this}
        target={target}
        show={active}
        outerStyle={{ left: `${positionLeft}px` }}
        className='popover-plannerhour'
        onHide={this.hide} // eslint-disable-line react/jsx-handler-names
        arrowClass='popovertip'
      >
        <div className='popover-content'>
          <div className='headerinfo'>
            <IconButton
              icon='reset'
              type='secondary'
              className='actionreset'
              canHover
              onClick={this._onResetHour.bind(this)}
            />
            <div className='actioninfo'>
              <IconButton
                icon='-'
                size='big'
                iconSize='8'
                type='secondary'
                className='actionminus'
                canHover
                onClick={this._onChangeHour.bind(this, false)}
              />
              <div className='hourblock'>
                <div className='hourwrap'>
                  <div
                    className='action'
                    onClick={this._onInfinityHour.bind(this)}
                  >
                    <SvgIcon name='allday' size='16' className='iconcont' />
                  </div>
                  <div className='cont'>{item ? item.noHours : 0}</div>
                </div>
              </div>
              <IconButton
                icon='+'
                size='big'
                iconSize='12'
                type='primary'
                className='actionplus'
                onClick={this._onChangeHour.bind(this, true)}
              />
            </div>
            <div className='popoverclose'>
              <IconButton
                icon='x'
                type='secondary'
                canHover
                onClick={this.hide} // eslint-disable-line react/jsx-handler-names
              />
            </div>
          </div>
          <div className='projectinfo'>
            <div className='current-projectinfo'>
              <div className='current-hourinfo'>
                <IntlMessage ident='popover.popover.currentTaskInfo' />
              </div>
              <div className='current-projectitem'>
                {currentProjectTitle !== '' && (
                  <div className='titlehour-info'>
                    <div className='project'>{currentProjectTitle}</div>
                    <div className='activityhour'>{currentProjectNoHours}</div>
                  </div>
                )}
              </div>
            </div>
            <div className='other-projectinfo'>
              {otherProjects.length > 0 && (
                <div className='other-hourinfo'>
                  <IntlMessage ident='popover.popover.otherTaskInfo' />
                </div>
              )}
              <div className='other-projectitem'>
                {otherProjects.map((project, idx) => (
                  <div className='titlehour-info' key={idx}>
                    <div className='project'>{project.title}</div>
                    <div className='activityhour'>{project.noHours}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className='linebreak' />
          <div className='popover-bottom'>
            <div className='totalhours'>{totalHours}</div>
          </div>
        </div>
      </Popover>
    )
  }

  /* Private Functions */
  _changeAndReloadHours (item, noHours) {
    const { onChangeHour } = this.props
    if (onChangeHour) {
      const prevNoHours = item.noHours
      item.noHours = noHours

      this.setState({ dataDate: new Date() })

      item.scheduledHours -= prevNoHours
      onChangeHour(item.date, item.noHours)

      if (this._reloadTimer) {
        window.clearTimeout(this._reloadTimer)
        this._reloadTimer = null
      }

      this._reloadTimer = window.setTimeout(() => {
        this._onReload()
      }, 1000)
    }
  }

  _onResetHour () {
    const { item } = this._data
    this._changeAndReloadHours(item, 0)
  }

  _onInfinityHour () {
    const { item } = this._data

    // Calculate the remaining duration
    let remainingDuration =
      item.duration / 60 - item.scheduledHours + item.noHours
    if (remainingDuration < 0) {
      remainingDuration = 0
    }

    /*
    console.log('ITEM Duration', item.duration);
    console.log('ITEM noHours', item.noHours);
    console.log('ITEM scheduledHours', item.scheduledHours);
    console.log('ITEM remainingDuration', remainingDuration);
    */

    const noHours = Math.round(
      item.availableHours < remainingDuration
        ? item.availableHours
        : remainingDuration
    )

    // console.log('ITEM noHours', noHours);
    this._changeAndReloadHours(item, noHours)
  }

  _onChangeHour (bIncr) {
    const { item } = this._data
    let noHours = item.noHours

    noHours += bIncr ? 1 : -1
    if (noHours < 0 || noHours > 24) {
      noHours = 0
    }

    this._changeAndReloadHours(item, noHours)
  }
}

export default PopoverPlannerHour
